import { Suspense, lazy } from "react";

// Loaded on demand: the panel uses the platform's app parts, which the
// package entry must not import.
const Panel = lazy(() => import("./PromptsPanel").then((m) => ({ default: m.PromptsPanel })));

/** Beside the Data Manager's table: the prompts behind the records. */
export const PromptsPanelLazy = (props) =>
  props.project?.extensions?.collection?.mode === "open" ? (
    <Suspense fallback={null}>
      <Panel {...props} />
    </Suspense>
  ) : null;
